import React, { useEffect, useRef } from "react"
import HeaderTools from "./header/HeaderTools";
import { useGlobal } from "../../core/Global";
type LayoutProps = {
  children: any
  wide?: boolean
  container?: boolean
  noToolbar?: boolean
  fitToolbar?: boolean
  paddingTop?: number
  paddingBottom?: number
}
function Layout(props: LayoutProps) {

  const [globalState, globalStateSet] = useGlobal()


  useEffect(() => {
    if (props.paddingTop) {
      //ContentDiv.current?.style.setProperty("padding-top", props.paddingTop + props.paddingTop > 0 ? "px": "", "important")
    }
  }, [props.paddingTop])

  useEffect(() => {
    globalStateSet({
      noToolbar: props.noToolbar,
      fitToolbar: props.fitToolbar
    })
  }, [props.noToolbar, props.fitToolbar])

  return (
    <div className="content d-flex flex-column flex-column-fluid" id="kt_content"
      style={{
        paddingTop: props.paddingTop,
        paddingBottom: props.paddingBottom
      }}>
      {
        props.noToolbar ? <></>
          : <HeaderTools />
      }

      {
        props.wide &&
        <div id="kt_content_container">
          {props.children}
        </div>
      }
      {
        !props.wide &&
        <div className="post d-flex flex-column-fluid" id="kt_post">
          <div id="kt_content_container" className="container-xxl">
            {props.children}
          </div>
        </div>
      }
    </div>
  );
}

export default Layout;
